

function videoPlayback() {
    window.addEventListener("DOMContentLoaded", function () {
        var players = Array.from(document.querySelectorAll("[data-player]"));

        function setIcon(button, iconName, label) {
            button.innerHTML = '<i data-lucide="' + iconName + '"></i><span>' + label + "</span>";
            if (window.lucide) {
                window.lucide.createIcons();
            }
        }

        function attachMuxStream(video, card, muxHlsUrl) {
            if (video.dataset.sourceAttached === "true") {
                return Promise.resolve();
            }

            video.dataset.sourceAttached = "true";
            card.classList.add("is-loaded");

            if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = muxHlsUrl;
                return Promise.resolve();
            }

            var hls = new window.Hls({
                maxBufferLength: 20
            });

            hls.on(window.Hls.Events.ERROR, function (eventName, data) {
                if (data && data.fatal) {
                }
            });

            hls.loadSource(muxHlsUrl);
            hls.attachMedia(video);
            video._hls = hls;

            return new Promise(function (resolve) {
                hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                    resolve();
                });
            });
        }

        function updateButtons(card, video) {
            var playButtons = Array.from(card.querySelectorAll('[data-action="play"]'));
            var muteButton = card.querySelector('[data-action="mute"]');

            playButtons.forEach(function (button) {
                if (button.classList.contains("poster-button")) {
                    return;
                }
                //   setIcon(button, video.paused ? "play" : "pause", video.paused ? "Play" : "Pause");
            });

            if (muteButton) {
                muteButton.classList.toggle("warning", video.muted);
            }

            card.classList.toggle("is-playing", !video.paused);
        }

        function initialisePlayer(card) {
            var video = card.querySelector("video");
            var shouldAutoplay = card.dataset.player === "autoplay";
            var muxPlaybackId = card.getAttribute("data-mux-id");
            var muxHlsUrl = "https://stream.mux.com/" + muxPlaybackId + ".m3u8";

            card.addEventListener("click", function (event) {
                var button = event.target.closest("button[data-action]");
                if (!button || !card.contains(button)) {
                    return;
                }

                var action = button.dataset.action;

                if (action === "play") {
                    attachMuxStream(video, card, muxHlsUrl).then(function () {
                        if (video.paused) {
                            if (!shouldAutoplay) {
                                video.muted = false;
                            }
                            return video.play();
                        }
                        video.pause();
                        return Promise.resolve();
                    }).then(function () {
                        updateButtons(card, video);
                    }).catch(function (error) {
                    });
                }

                if (action === "mute") {
                    video.muted = !video.muted;
                    updateButtons(card, video);
                }

                if (action === "restart") {
                    attachMuxStream(video, card, muxHlsUrl).then(function () {
                        video.currentTime = 0;
                        return video.play();
                    }).then(function () {
                        updateButtons(card, video);
                    }).catch(function (error) {
                    });
                }
            });

            video.addEventListener("play", function () {
                // Pause all other videos (except autoplay ones) when this one starts playing
                document.querySelectorAll("[data-player] video").forEach(function (otherVideo) {
                    if (otherVideo !== video) {
                        var otherCard = otherVideo.closest('[data-player]');
                        var otherAutoplay = otherCard && otherCard.dataset.player === "autoplay";
                        if (!otherAutoplay) {
                            otherVideo.pause();
                        }
                    }
                });
                updateButtons(card, video);
            });

            video.addEventListener("pause", function () {
                updateButtons(card, video);
            });

            video.addEventListener("waiting", function () {
                var playButton = card.querySelector('.control-button.play');
                if (playButton) {
                    playButton.classList.add('loading');
                }
            });

            video.addEventListener("canplay", function () {
                var playButton = card.querySelector('.control-button.play');
                if (playButton) {
                    playButton.classList.remove('loading');
                }
            });

            if (shouldAutoplay) {
                attachMuxStream(video, card, muxHlsUrl).then(function () {
                    return video.play();
                }).then(function () {
                    updateButtons(card, video);
                }).catch(function () {
                    updateButtons(card, video);
                });
            } else {
                updateButtons(card, video);
            }
        }

        players.forEach(initialisePlayer);

        if (window.lucide) {
            window.lucide.createIcons();
        }
    });


    jQuery(document).ready(function ($) {
        $('.component--video').each(function () {
            const grid = $(this).find('.multiple-videos-splide')[0];

            if (grid) {
                new Splide(grid).mount();
            }
        });
    });
}

export default videoPlayback;